import { render, staticRenderFns } from "./WritingtypeTable.vue?vue&type=template&id=7ff2864c&scoped=true&"
import script from "./WritingtypeTable.vue?vue&type=script&lang=js&"
export * from "./WritingtypeTable.vue?vue&type=script&lang=js&"
import style0 from "./WritingtypeTable.vue?vue&type=style&index=0&id=7ff2864c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff2864c",
  null
  
)

export default component.exports